import React, { useState } from "react";

/**
 * Card hover popover wrapper.
 * When hovered, displays the supplied 'popover' content.
 */
export default function HoverPopover({ popover, children }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      tabIndex={0}
      onBlur={() => setHovered(false)}
    >
      {children}
      {hovered && (
        <div
          className="absolute z-30 left-1/2 -translate-x-1/2 top-full mt-spacing-2 w-max min-w-56 bg-bg-card rounded-lg border border-border-default p-spacing-4"
          style={{ whiteSpace: "nowrap" }}
        >
          {popover}
        </div>
      )}
    </div>
  );
}
